import { createTheme } from '@mui/material';

// Tema Escuro
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#64b5f6',
    },
    background: {
      default: '#0a0a0a',
      paper: '#141414',
    },
    text: {
      primary: '#e0e0e0',
      secondary: '#a0a0a0',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    h6: {
      fontWeight: 400,
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#1c1c1c',
            // Estilos para o estado desativado
            '&.Mui-disabled': {
              opacity: 0.5,
              backgroundColor: '#2a2a2a',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#444444',
              },
              '& .MuiInputBase-input': {
                color: '#a0a0a0',
                cursor: 'not-allowed',
                paddingRight: '30px', // Espaço para o ícone
                position: 'relative',
                '&::after': {
                  content: '"🔒"',
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#a0a0a0',
                  fontSize: '1rem',
                },
              },
            },
          },
          '& .MuiInputLabel-root.Mui-disabled': {
            color: '#a0a0a0',
            opacity: 0.6,
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#1c1c1c',
            // Estilos para o estado desativado
            '&.Mui-disabled': {
              opacity: 0.5,
              backgroundColor: '#2a2a2a',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#444444',
              },
              '& .MuiSelect-select': {
                color: '#a0a0a0',
                cursor: 'not-allowed',
                paddingRight: '30px', // Espaço para o ícone
                position: 'relative',
                '&::after': {
                  content: '"🔒"',
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#a0a0a0',
                  fontSize: '1rem',
                },
              },
            },
          },
          '& .MuiInputLabel-root.Mui-disabled': {
            color: '#a0a0a0',
            opacity: 0.6,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#a0a0a0',
          '&:hover': {
            color: '#64b5f6',
            backgroundColor: 'rgba(100, 181, 246, 0.1)',
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#1c1c1c',
          borderRadius: '4px',
          fontSize: '0.9rem',
        },
      },
    },
  },
});

// Tema Claro
const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    h6: {
      fontWeight: 400,
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#ffffff',
            // Estilos para o estado desativado
            '&.Mui-disabled': {
              opacity: 0.5,
              backgroundColor: '#f0f0f0',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#d0d0d0',
              },
              '& .MuiInputBase-input': {
                color: '#757575',
                cursor: 'not-allowed',
                paddingRight: '30px', // Espaço para o ícone
                position: 'relative',
                '&::after': {
                  content: '"🔒"',
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#757575',
                  fontSize: '1rem',
                },
              },
            },
          },
          '& .MuiInputLabel-root.Mui-disabled': {
            color: '#757575',
            opacity: 0.6,
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#ffffff',
            // Estilos para o estado desativado
            '&.Mui-disabled': {
              opacity: 0.5,
              backgroundColor: '#f0f0f0',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#d0d0d0',
              },
              '& .MuiSelect-select': {
                color: '#757575',
                cursor: 'not-allowed',
                paddingRight: '30px', // Espaço para o ícone
                position: 'relative',
                '&::after': {
                  content: '"🔒"',
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#757575',
                  fontSize: '1rem',
                },
              },
            },
          },
          '& .MuiInputLabel-root.Mui-disabled': {
            color: '#757575',
            opacity: 0.6,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#757575',
          '&:hover': {
            color: '#1976d2',
            backgroundColor: 'rgba(25, 118, 210, 0.1)',
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#424242',
          borderRadius: '4px',
          fontSize: '0.9rem',
        },
      },
    },
  },
});

export { darkTheme, lightTheme };